<script lang="ts">
	import classNames from 'classnames';
	import { TalksSpeakersCard } from '#lib/websites/talks/components/TalksSpeakersCard/index.js';
	import { page } from '$app/state';
	import { getImageUrl } from '$global/utils/getImageUrl';
	import type { TalksPDPPageData } from '$routes/talks/[slug]/types';

	interface Props {
		dataCy: string;
		artistSlugs: string[];
		podcastOpenpanelPrefix: string;
	}

	let { dataCy, artistSlugs, podcastOpenpanelPrefix }: Props = $props();

	let speakers = $derived(page.data.speakers as TalksPDPPageData['speakers']);
</script>

{#if speakers}
	{#each speakers as s, i}
		{@const speaker = s?.HENI_Talks_Speakers_id}
		<TalksSpeakersCard
			{artistSlugs}
			{podcastOpenpanelPrefix}
			hasTalks={(speaker?.HENI_Talks_Talks_func?.count ?? 0) > 0}
			name={`${speaker?.name}`}
			biography={s?.biographyTokens}
			professionalTitle={speaker?.professional_title}
			image={getImageUrl(speaker?.profile_image?.filename_disk)}
			twitter={speaker?.twitter_handle || ''}
			insta={speaker?.instagram_handle || ''}
			{dataCy}
			class={classNames({ 'mt-4': !!i })}
		/>
	{/each}
{/if}
